import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import Loader from "../components/other/Loader";
import { getVarificationData } from "../redux/action/userAction";
import NoRecord from "../components/other/NoRecord";
import { pipTimeView, pipViewDate2 } from "../utils/pip";

const Verifications = () => {
  const navigate = useNavigate();
  const [filterValue, setFilterValue] = useState('');
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state.authReducer);
  const { isLoading, verificationdata } = useSelector(
    (state) => state.userReducer
  );

  const displayData = filterValue == '' ? verificationdata : filterValue == "pending" ? verificationdata.filter((item) => (item?.is_verified == 2)) :
    filterValue == "verified" ? verificationdata.filter((item) => (item?.is_verified == 1)) : filterValue == 'unverified' ? verificationdata.filter((item) => (item?.is_verified == 3)) : filterValue == "new" ? [...verificationdata].sort((a, b) => new Date(b.facial_verification_time) - new Date(a.facial_verification_time)) : verificationdata;

  useEffect(() => {
    dispatch(getVarificationData());
  }, [dispatch]);

  if (isLoading) {
    return <Loader />;
  };

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div className="ct_right_content">
          <Header />
          <div className="ct_inner_dashbaord_main">
            <div className="row ">
              <div className="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                {/* <h3 className="ct_fs_22 ct_ff_roboto mb-4 ct_fw_600 ">Dashboard</h3> */}
                <div className="ct_top_sticky">
                  <div className="">
                    <div className="d-flex align-items-center gap-3 justify-content-between ct_flex_column_767">
                      <ul className="d-flex align-items-center  gap-2 mb-0">
                        <li>
                          {" "}
                          <h4 className="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            All Verification Request
                          </h4>
                        </li>
                      </ul>
                      <div class="ct_left_header_cnt">
                        <div>
                          <label class="mb-2 ct_fw_600">
                            Sort by verification status
                          </label>
                          <select
                            name="status"
                            className="form-control ct_input ct_pointer_curser"
                            value={filterValue}
                            onChange={(e) => setFilterValue(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value='pending'>Pending</option>
                            <option value='verified'>Verified</option>
                            <option value='unverified'>Unverified</option>
                            <option value='new'>Newest To Oldest</option>

                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-4">
                      {displayData && displayData != 0 ? (
                        displayData?.map((item, index) => {
                          return (
                            <div className="col-xl-3 col-lg-6 col-md-6 mb-4 md-lg-3">
                              <div className="ct_latesh_photo_update">
                                <figure>
                                  <div className="ct_latest_img_34">
                                    <div className="position-relative">
                                      <img
                                        src={
                                          item?.verification_image ??
                                          "/user_profile.png"
                                        }
                                        alt=""
                                      />
                                      {/* "#ff0000" "#f66315" */}
                                      <span className="ct_full_access_ribbin"
                                        style={{ background: item?.is_verified == 0 ? "#f66315" : item?.is_verified == 1 ? "#11b90d" : item?.is_verified == 2 ? "#f66315" : item?.is_verified == 2 ? "#ff0000" : '' }}>
                                        {item?.is_verified == 0 ? 'No Action' : item?.is_verified == 1 ? 'Accepted' : item?.is_verified == 2 ? 'Pending' : item?.is_verified == 3 ? 'Rejected' : ''}</span>
                                      <div className="ct_verification_request_view_btn_top">
                                        <a
                                          href="javascript:void(0)"
                                          onClick={() =>
                                            navigate(pageRoutes?.verificationRequest, { state: { value: item } })
                                          }
                                          class="ct_orange_btn ct_btn_h_44 w-100 d-flex  align-items-center justify-content-center"
                                        >
                                          View Request
                                        </a>
                                      </div>
                                    </div>
                                    <div className="ct_latest_photo_overlay">
                                      <img
                                        src={
                                          item?.images[0] ??
                                          "/user_profile.png"
                                        }
                                        alt=""
                                        className="ct_img_69"
                                      />
                                      <div>
                                        <h4 className="ct_fs_20 ct_fw_600 mb-1">
                                          {item?.name}, {item?.age}
                                        </h4>
                                        <p className=" ct_fw_500 mb-1 ct_fs_12">
                                          <i className="bi bi-geo-alt-fill me-1"></i>
                                          {item?.country}
                                        </p>
                                        <p className="ct_fw_500 mb-0 ct_fs_12">
                                          Upload at {pipTimeView(item?.update_at)}
                                          {pipViewDate2(item?.update_at)}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </figure>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <NoRecord />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Verifications;
